/* ue-total-price.js — 수량 옆 총가격 (2026-09-13 의장 ②)
   수량 x 한 개 값을 그린다. 수량이 바뀌면 바뀌고, 옵션이 바뀌면 단가도 바꿔 다시 센다.

   왜 만들었나: 라이브는 같은 자리에 **변형 한 개 값**을 Liquid 로 한 번 찍고 끝이다.
   자바스크립트가 없어 수량을 3으로 올려도 금액이 그대로다(라이브 테마 전수 확인).

   ⚠ 처음 판이 틀렸던 곳 (2026-09-13 의장 「색상 하나 선택 후 2개 고르고 다른색상 고르니 안되네」):
     옵션을 바꾸면 테마가 **수량칸을 통째로 다시 그린다.** 그 칸에 직접 붙여 둔 귀는 같이 사라지고,
     줄에 「이미 붙였음」 표시가 남아 있어 다시 붙지도 않았다.
     → 이제 **귀를 문서에 붙이고**(위임) 줄 안이 바뀌는 것도 지켜본다. 다시 그려져도 살아 있다. */

(function () {
  'use strict';

  function 표기틀() {
    try {
      var v = window.themeVariables;
      if (v && v.settings && v.settings.moneyFormat) { return v.settings.moneyFormat; }
    } catch (e) { /* 무시 */ }
    return '${{amount}}';
  }

  function 쉼표(n, 기호) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, 기호); }

  function 돈(센트) {
    센트 = Math.round(센트);
    var 정수 = Math.floor(Math.abs(센트) / 100);
    var 소수 = ('0' + (Math.abs(센트) % 100)).slice(-2);
    return String(표기틀()).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, 이름) {
      switch (이름) {
        case 'amount':                                     return 쉼표(정수, ',') + '.' + 소수;
        case 'amount_no_decimals':                         return 쉼표(정수, ',');
        case 'amount_with_comma_separator':                return 쉼표(정수, '.') + ',' + 소수;
        case 'amount_no_decimals_with_comma_separator':    return 쉼표(정수, '.');
        case 'amount_with_apostrophe_separator':           return 쉼표(정수, "'") + '.' + 소수;
        case 'amount_with_space_separator':                return 쉼표(정수, ' ') + ',' + 소수;
        case 'amount_no_decimals_with_space_separator':    return 쉼표(정수, ' ');
        default:                                           return 쉼표(정수, ',') + '.' + 소수;
      }
    });
  }

  function 다시(줄) {
    if (!줄) { return; }
    var 칸 = 줄.querySelector('[data-ue-qty-total]');
    var 수량칸 = 줄.querySelector('input[name="quantity"]');
    if (!칸 || !수량칸) { return; }
    var 단가 = parseInt(줄.getAttribute('data-unit'), 10);
    if (isNaN(단가)) { return; }
    var 개수 = parseInt(수량칸.value, 10);
    if (isNaN(개수) || 개수 < 1) { 개수 = 1; }
    var 새글 = 돈(단가 * 개수);
    if (칸.textContent.trim() !== 새글) { 칸.textContent = 새글; }
  }

  function 모두() {
    var 목록 = document.querySelectorAll('[data-ue-qty-row]');
    for (var i = 0; i < 목록.length; i++) { 다시(목록[i]); }
  }

  /* ③ 줄이 **통째로 새 노드로 바뀌는 것**까지 지켜본다.
        실측: 색을 바꾸면 [data-ue-qty-row] 가 같은 노드가 아니게 된다(같은노드 false).
        그래서 줄이 아니라 **그 위 상자**를 지켜본다 — 줄이 갈려도 그 위는 남는다. */
  var 감시 = null, 기다림 = false;

  function 켜기() {
    if (!window.MutationObserver) { return; }
    if (!감시) {
      감시 = new MutationObserver(function () {
        if (기다림) { return; }
        기다림 = true;
        window.requestAnimationFrame(function () { 기다림 = false; 모두(); });
      });
    }
    /* 줄도 그 위 상자도 다시 그려질 수 있다. **구간(section)** 은 갈리지 않으므로 거기에 건다. */
    var 목록 = document.querySelectorAll('[data-ue-qty-row]');
    for (var i = 0; i < 목록.length; i++) {
      var 위 = 목록[i].closest('[id^="shopify-section-"]') || 목록[i].parentElement || 목록[i];
      if (위.dataset.ue총가격감시 === '1') { continue; }
      위.dataset.ue총가격감시 = '1';
      감시.observe(위, { childList: true, subtree: true, attributes: true,
                        attributeFilter: ['value', 'data-unit'] });
    }
  }

  function 줄찾기(요소) {
    return (요소 &&요소.closest) ? 요소.closest('[data-ue-qty-row]') : null;
  }

  /* ① 귀는 문서에 붙인다 — 수량칸이 다시 그려져도 살아 있다 */
  ['input', 'change'].forEach(function (n) {
    document.addEventListener(n, function (e) {
      if (e.target && e.target.name === 'quantity') { 다시(줄찾기(e.target)); }
    }, true);
  });

  /* 단추는 값을 바꾸고도 사건을 안 띄우는 경우가 있다 — 누른 다음 차례에 한 번 더 본다 */
  document.addEventListener('click', function (e) {
    var 줄 = 줄찾기(e.target);
    if (줄) { window.setTimeout(function () { 다시(줄); }, 0); }
  }, true);

  /* ── 옵션을 바꾸면 수량을 1로 되돌린다 (2026-09-14 의장 「처음부터 그렇게 하지」) ──
     왜: 제품 폼은 「변형 하나 + 수량 하나」다. 수량 2로 두고 색을 바꾸면 **그 2가 새 색에 붙는다.**
     브라운 2개로 알고 색만 바꿨는데 그린 2개가 담긴다(라이브에도 있는 결함, 실측 확인).
     화면에 남은 숫자가 방금 고른 색에 대한 뜻이 아닌데 그렇게 읽히는 것이 문제의 뿌리다.

     테마의 variant:change 는 1.5초 뒤에 온다(0-22). 기다리면 그 사이에 담길 수 있으므로
     **누른 즉시** 되돌린다. 테마 사건은 뒤늦게 와도 같은 결과라 문제 없다. */
  function 수량되돌리기(줄) {
    var 수량칸 = 줄.querySelector('input[name="quantity"]');
    if (!수량칸) { return; }
    var 최소 = parseInt(수량칸.getAttribute('min'), 10);
    if (isNaN(최소) || 최소 < 1) { 최소 = 1; }
    if (parseInt(수량칸.value, 10) === 최소) { return; }   /* 이미 그 값이면 건드리지 않는다 */
    수량칸.value = String(최소);
    수량칸.dispatchEvent(new Event('change', { bubbles: true }));
    다시(줄);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }
    /* 옵션을 고르는 요소를 누른 경우만. 자리(어느 상자 안인지)로 판단하지 않는다(0-23) */
    var 옵션 = e.target.closest('[role="option"]')
            || e.target.closest('.color-swatch')
            || e.target.closest('.product-form__option-selector label');
    if (!옵션) { return; }
    window.requestAnimationFrame(function () {
      var 목록 = document.querySelectorAll('[data-ue-qty-row]');
      for (var i = 0; i < 목록.length; i++) { 수량되돌리기(목록[i]); }
    });
  }, true);

  /* ② 옵션이 바뀌면 단가가 바뀐다. 테마가 form 에 사건을 띄운다(문서까지 올라온다).
        테마가 수량칸을 다시 그리는 것도 이때다 — 그려진 뒤에 세도록 한 차례 미룬다. */
  ['variant:change', 'variant:changed'].forEach(function (n) {
    document.addEventListener(n, function (e) {
      var v = e.detail && e.detail.variant;
      var 목록 = document.querySelectorAll('[data-ue-qty-row]');
      for (var i = 0; i < 목록.length; i++) {
        if (v && typeof v.price !== 'undefined') { 목록[i].setAttribute('data-unit', String(v.price)); }
      }
      /* 시간에 기대지 않는다 — 다시 그려지는 순간은 아래 감시가 잡는다
         (2026-09-13: 0ms·250ms 로 기다리던 것을 걷어냈다. 느린 기기에서 어긋났다) */
      모두();
    }, true);
  });


  function 시작() { 켜기(); 모두(); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', 시작); }
  else { 시작(); }
  document.addEventListener('shopify:section:load', 시작);
})();
